import { render } from "./EventInfoSidebarContent.vue?vue&type=template&id=481caadd&ts=true"
import script from "./EventInfoSidebarContent.vue?vue&type=script&lang=ts"
export * from "./EventInfoSidebarContent.vue?vue&type=script&lang=ts"

import "./EventInfoSidebarContent.vue?vue&type=style&index=0&id=481caadd&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__